const TOGGLE_LIGHTS = 'TOGGLE_LIGHTS';
const TOGGLE_SPACE = 'TOGGLE_SPACE';
const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE';

export { TOGGLE_LIGHTS, TOGGLE_SPACE, TOGGLE_DARK_MODE };